module.exports = __webpack_public_path__ + "assets/images/calendar-month.cc0fbfdbdf86d29bc46054875a4833ed.svg";